<template>
  <div class="mod-dial settings-setup" @click="INTRO_SET_SETTINGS_MODAL_VISIBLE(false)">
    <div class="mod-cont" @click.stop>
      <span class="close" @click="INTRO_SET_SETTINGS_MODAL_VISIBLE(false)">
        <i class="bi bi-x-lg"></i>
      </span>
      <div class="mod-body mod-settings">
        <div class="settings-body">
          <ul class="settings-tabs">
            <li class="btn-st-grey" :class="{ active: activeTab === 'plan' }" @click="activeTab = 'plan'">
                {{ $t('PROFILE_TITLE') }}
            </li>
            <li class="btn-st-grey"  :class="{ active: activeTab === 'access' }" @click="activeTab = 'access'">
                {{ $t('ACCESS_MANAGER_RIGHTS_MANAGER') }}
            </li>
            <li class="btn-st-grey" style="display:none;" :class="{ active: activeTab === 'autoreport' }" @click="activeTab = 'autoreport'">
                {{ $t('REPORTS_MANAGE') }} <!--пока скрыл, не тестилось-->
            </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content">
            <div v-show="activeTab === 'plan'">
              <!-- Plan Information Content -->
              <h3 class="tab-title">{{ $t('PROFILE_TITLE') }}</h3>
              <div class="account-info">
                <div class="info-block">
                  <span class="info-title">E-mail</span>
                  <span class="info-value">{{ getProfile.email }} <span class="logout" @click.stop="AUTH_LOGOUT">({{ $t('HEADER_LOG_OUT') }})</span></span>
                </div>
                <div class="info-block">
                  <span class="info-title">{{ $t('PRC_PLN') }}</span>
                  <span class="info-value">{{ getProfile.plan }}</span>
                </div>
                <div class="info-block">
                  <span class="info-title">{{ $t('PRC_USED') }}</span>
                  <span class="info-value">{{ getProfile.pageCount }}/{{ getProfile.page_limit }}</span>
                </div>
                <div class="info-block">
                  <span class="info-title">{{ $t('PRC_ADMIN_USED') }}</span>
                  <span class="info-value">{{ getProfile.adminUserCount }}/{{ getProfile.admin_limit }}</span>
                </div>
                <div class="info-block">
                  <span class="info-title">{{ $t('PRC_EXPR') }}</span>
                  <span class="info-value">{{ getProfile.expire }}</span>
                </div>
              </div>
              <div class="mod-foot">
                <div class="b14">
                  {{ $t("AUTH_ACTIVE") }}
                </div>
                <SocialAuthButtons :selectedAccessEmail="userEmail" />
              </div>
            </div>
            <div v-show="activeTab === 'access'">
              <AccessManager />
            </div>
            <div v-show="activeTab === 'autoreport'">
              <AutoReportSettings />
            </div>
            
            <button class="btn-st-viol btn-st-bg" @click="INTRO_SET_SETTINGS_MODAL_VISIBLE(false)">
              {{ $t('ACCESS_MANAGER_CLOSE') }}
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import AccessManager from './AccessManager';
import { mapGetters, mapMutations, mapActions } from "vuex";
import AutoReportSettings from './AutoReportSettings';
import { AUTH_LOGOUT, AUTH_SOCIAL_TOKENS } from "@/store/actions/auth";
import AddPage from './AddPage';
import { INTRO_SET_SETTINGS_MODAL_VISIBLE } from "../../store/actions/intro";
import SocialAuthButtons from '@/components/SocialAuthButtons.vue';

export default {
  name: 'SettingsModal',
  components: {
    AccessManager,
    AutoReportSettings,
    AddPage,
    SocialAuthButtons
  },
  data() {
    return {
      activeTab: 'plan', // default active tab
    };
  },
  computed: {
    ...mapGetters(['getProfile','getSocialTokens']),
    userEmail() {
      return this.getProfile.email;
    },
  },
  methods: {
    ...mapMutations({
      INTRO_SET_SETTINGS_MODAL_VISIBLE: INTRO_SET_SETTINGS_MODAL_VISIBLE,
    }),
    ...mapActions([AUTH_LOGOUT]),
  },
  async mounted() {
    if (!this.getSocialTokens || Object.keys(this.getSocialTokens).length === 0) {
      await this.$store.dispatch(AUTH_SOCIAL_TOKENS);
    }
  },
};
</script>